/**
 * iter1031 — BHI Dashboard Preview (statik demo)
 *
 * Standalone preview page for the two-column dashboard layout — не пипа
 * съществуващата BreastHealthIntelligencePage. Ползва mock данни, за да
 * покаже как ще изглежда layout-a след пълна интеграция.
 */
import React, { useState } from "react";
import { useTheme } from "@/theme/ThemeContext";
import { Layout as LayoutIcon, Sparkles } from "lucide-react";
import BhiDashboardSidebar from "@/components/breast_intel/BhiDashboardSidebar";
import BhiDashboardGrid from "@/components/breast_intel/BhiDashboardGrid";

export default function BhiDashboardPreviewPage() {
  const { isDark } = useTheme();
  const [activeId, setActiveId] = useState("patient-journey");
  const [view, setView] = useState("dashboard"); // "dashboard" | "classic"

  const bgCls = isDark
    ? "bg-[hsl(222,47%,6%)] text-white"
    : "bg-[#F8FAFC] text-[#1A1A2E]";

  const handleNavigate = (item) => {
    setActiveId(item.id);
    const el = document.querySelector(`[data-testid="bhi-dash-tile-${item.id}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className={`min-h-screen ${bgCls}`}>
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-6">
        {/* Top hero — matches BhiHero style */}
        <header className={`rounded-2xl border p-5 mb-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 ${
          isDark ? "bg-gradient-to-r from-purple-900/40 via-pink-900/30 to-transparent border-slate-800"
                 : "bg-gradient-to-r from-purple-50 via-pink-50 to-white border-slate-200"
        }`}>
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${
            isDark ? "bg-white/10" : "bg-white shadow"
          }`}>
            <Sparkles className="w-6 h-6 text-purple-500" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-semibold text-purple-500 uppercase tracking-wider">BHI Preview · iter1031</div>
            <h1 className="text-xl sm:text-2xl font-bold leading-tight">Breast Health Intelligence Dashboard</h1>
            <p className={`text-sm mt-0.5 ${isDark ? "text-slate-400" : "text-slate-600"}`}>
              Two-column изглед · sticky sidebar с 5 групи + търсене · модулен card grid
            </p>
          </div>
          {/* View toggle — Dashboard е default за ≥ 1280px (opt-out) */}
          <div className={`inline-flex rounded-lg border overflow-hidden ${isDark ? "border-slate-700" : "border-slate-300"}`}
               data-testid="bhi-view-toggle">
            <button
              onClick={() => setView("dashboard")}
              data-testid="bhi-view-dashboard"
              className={`px-3 py-1.5 text-xs font-semibold transition ${
                view === "dashboard"
                  ? "bg-emerald-600 text-white"
                  : (isDark ? "bg-slate-800 text-slate-300 hover:bg-slate-700" : "bg-white text-slate-600 hover:bg-slate-50")
              }`}
            >
              <LayoutIcon className="w-3.5 h-3.5 inline mr-1" />
              Dashboard
            </button>
            <button
              onClick={() => setView("classic")}
              data-testid="bhi-view-classic"
              className={`px-3 py-1.5 text-xs font-semibold transition border-l ${isDark ? "border-slate-700" : "border-slate-300"} ${
                view === "classic"
                  ? "bg-slate-700 text-white"
                  : (isDark ? "bg-slate-800 text-slate-300 hover:bg-slate-700" : "bg-white text-slate-600 hover:bg-slate-50")
              }`}
            >
              Classic
            </button>
          </div>
        </header>

        {/* Two-column layout */}
        <div className="flex gap-6 items-start">
          <BhiDashboardSidebar
            isDark={isDark}
            activeId={activeId}
            onNavigate={handleNavigate}
          />
          <BhiDashboardGrid isDark={isDark} />
        </div>

        {/* Footer note */}
        <div className={`mt-8 rounded-xl border p-4 text-xs ${
          isDark ? "bg-slate-900/50 border-slate-800 text-slate-400" : "bg-slate-50 border-slate-200 text-slate-500"
        }`}>
          <strong className={isDark ? "text-slate-200" : "text-slate-700"}>Preview note:</strong>{" "}
          Всички tile-ове са с mock данни. При интеграция ще замeним вътрешното съдържание със съществуващите компоненти
          (AIHealthSummary, BhiHero, PathwayAtlas, Nutritional Fingerprint), без да пипаме тяхната логика.
          Sidebar-a се крие под 1024px (mobile fallback → vertical stack).
        </div>
      </div>
    </div>
  );
}
